import { HTTP_WITHOUT_HEADER, HTTP } from '../../utils'

export const authenticateWidget = (key, secret, type) => {
  let url = '/widget/authenticate?key=' + key + '&secret=' + secret
  if (type) {
    url += '&type=' + type
  }
  return HTTP_WITHOUT_HEADER().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getWidgetIntroductionMessage = (key, secret, type) => {
  let url = '/widget/introductionMessage?key=' + key + '&secret=' + secret
  if (type) {
    url += '&type=' + type
  }
  return HTTP_WITHOUT_HEADER().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getWidgetDemoWidget = (key, secret, type) => {
  let url = '/widget/isDemoWidget?key=' + key + '&secret=' + secret
  if (type) {
    url += '&type=' + type
  }
  return HTTP_WITHOUT_HEADER().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const loginGuestUser = (institutionId) => {
  return HTTP_WITHOUT_HEADER().get('/guest/login/' + institutionId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const loginUnmudlUser = (institutionId, data) => {
  return HTTP_WITHOUT_HEADER().post('/guest/unmudl/login/' + institutionId, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const loginCourseReportingWidgetUser = (institutionId, data) => {
  return HTTP_WITHOUT_HEADER().post('/guest/courseReporting/login/' + institutionId, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCourseProgramProgress = (courseId, institutionId) => {
  return HTTP().get('/progress/courseProgramCredit/' + courseId + '/' + institutionId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateCourseProgramProgress = (streamId, programId) => {
  return HTTP().get('/progress/courseProgramCredit/' + streamId + '/' + programId + '/update')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const navigateToCareerProspect = (token) => {
  return HTTP().get('/user/navigateToCareerProspect?token=' + token)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populatePlanningStreamWithStructure = (userId) => {
  let url = '/entity/planningstream?isPopulateStructure=true'
  if (userId)
    url += '&userId=' + userId
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getProgramCatalogs = (programId) => {
  return HTTP().get('/programguide/getCatalogsByProgramId/' + programId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const addCatalogToPlanningStream = (uuid, entity) => {
  return HTTP().post('/entity/addCatalogToPlanningStream/' + uuid, entity)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/widget/api.js